export default {"src":"/_next/static/media/Thyroid-Cancer.9fd56d3b.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};